export const LOCAL_STORAGE_EMPTY_VALUE = null;

export enum LOCAL_STORAGE_KEYS {
  LOCALSTORAGE_USER_KEY = 'ars.currentUser',
  LOCALSTORAGE_CLIENT_KEY = 'ars.client',
  LOCALSTORAGE_COLLECTION = 'ars.collection',
  LOCALSTORAGE_EXHIBIT = 'ars.exhibit',
  LOCALSTORAGE_LANG = 'ars.lang',
}
